import { useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthProvider";
/**
 * Resolves the current user's manager via Graph `/me/manager`.
 * In mock mode Tim has no manager — drives the Self-approve tab.
 */
export function useManager() {
    const { isMock, user } = useAuth();
    const [manager, setManager] = useState(null);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (isMock) {
            // Tim has no manager; everyone else reports to Tim (drives My approvals queue).
            if (user.id === "tim-user-id")
                setManager(null);
            else
                setManager({ id: "tim-user-id", name: "Tim Raines" });
            setLoaded(true);
            return;
        }
        // Real Graph call deferred until MSAL is wired.
        setManager(null);
        setLoaded(true);
    }, [isMock, user.id]);
    return { manager, loaded, hasManager: !!manager };
}
